/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {GetterTree} from 'vuex';
import {RootState} from '@/store/types';
import {MessageInterface, MessageStateInterface} from '@/store/modules/message/types';

export const getters: GetterTree<MessageStateInterface, RootState> = {

    /**
     * Get the messages.
     *
     * @param {MessageStateInterface} state
     *
     * @returns {MessageInterface[]}
     */
    getMessages(state: MessageStateInterface): MessageInterface[] {
        return state.messages;
    },


};
